import Layout from "components/Layout";
import React from "react";
import ManualAddForm from "./components/ManualAddForm";

function AdminManualAddPage() {
  return (
    <Layout title="매뉴얼 등록">
      <ManualAddForm />
    </Layout>
  );
}

export default AdminManualAddPage;
